import { render, staticRenderFns } from "./ProductKitList.vue?vue&type=template&id=05f4a037&"
import script from "./ProductKitList.vue?vue&type=script&lang=js&"
export * from "./ProductKitList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05f4a037')) {
      api.createRecord('05f4a037', component.options)
    } else {
      api.reload('05f4a037', component.options)
    }
    module.hot.accept("./ProductKitList.vue?vue&type=template&id=05f4a037&", function () {
      api.rerender('05f4a037', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product-kit/ProductKitList.vue"
export default component.exports